import axios from '@/api/axios.config'

export type ProofGalleryResponse = {
  screenshotUrls?: string[]
  orderId?: string
  createdAt?: string
}

export const getProofGallery = async (pdfId: string, token: string) => {
  return await axios.get<ProofGalleryResponse>(
    `proof-gallery/${pdfId}/${token}`,
  )
}
